import { createSlice } from "@reduxjs/toolkit";
import { RootType } from "../models/RootType";

const RootTypeInitialState: {
	rootTypes: RootType[];
} = {
	rootTypes: [],
};

export const RootTypeReducer = createSlice({
	name: "__",
	initialState: RootTypeInitialState,
	reducers: {
		setRootTypes(state, { payload }) {
			state.rootTypes = payload;
		},
	},
});
